/**
 * API POD (S5.6 PR3 → PR-C) — wrapping autour de `apiClient`.
 *
 * S5.6 PR-C — `listProviders`, `listConnections`, `connect`, `disconnect`
 * supprimés. La voie UI portail Gelato a été démantelée — la clé Gelato
 * vit en `.env` de prod, plus de gestion HTTP des credentials atelier.
 */

import { apiClient } from './client'
import type { PodPreparePayload, PodProductResponse } from '@/types/pod'

export const podApi = {
  // ── Variant-scoped (prepare / status / archive) ──────────────────────
  /** Retourne `null` si la variante n'a aucune row POD active — pas une erreur. */
  getVariantStatus: async (variantId: number): Promise<PodProductResponse | null> => {
    const { data } = await apiClient.get<PodProductResponse | null>(`/variants/${variantId}/pod`)
    return data
  },

  prepareVariant: async (
    variantId: number,
    payload: PodPreparePayload,
  ): Promise<PodProductResponse> => {
    const { data } = await apiClient.post<PodProductResponse>(
      `/variants/${variantId}/pod/prepare`,
      payload,
    )
    return data
  },

  archiveVariant: async (variantId: number): Promise<void> => {
    await apiClient.delete(`/variants/${variantId}/pod`)
  },
}
